module.exports = ":host() {\n  display: block;\n  height: 100%; }\n\n.sgc-page {\n  height: 100%; }\n"